/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HistoriqueRouteImport } from './routes/historique'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProfilRouteImport } from './routes/profil'
import { Route as ResultatIdRouteImport } from './routes/resultat.$id'
import { Route as ResultatIdIndexRouteImport } from './routes/resultat.$id.index'
import { Route as ResultatIdAnalyseRouteImport } from './routes/resultat.$id.analyse'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoriqueRoute = HistoriqueRouteImport.update({
  id: '/historique',
  path: '/historique',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilRoute = ProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultatIdRoute = ResultatIdRouteImport.update({
  id: '/resultat/$id',
  path: '/resultat/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultatIdIndexRoute = ResultatIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResultatIdRoute,
} as any)
const ResultatIdAnalyseRoute = ResultatIdAnalyseRouteImport.update({
  id: '/analyse',
  path: '/analyse',
  getParentRoute: () => ResultatIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/historique': typeof HistoriqueRoute
  '/login': typeof LoginRoute
  '/profil': typeof ProfilRoute
  '/resultat/$id': typeof ResultatIdRouteWithChildren
  '/resultat/$id/analyse': typeof ResultatIdAnalyseRoute
  '/resultat/$id/': typeof ResultatIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/historique': typeof HistoriqueRoute
  '/login': typeof LoginRoute
  '/profil': typeof ProfilRoute
  '/resultat/$id/analyse': typeof ResultatIdAnalyseRoute
  '/resultat/$id': typeof ResultatIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/historique': typeof HistoriqueRoute
  '/login': typeof LoginRoute
  '/profil': typeof ProfilRoute
  '/resultat/$id': typeof ResultatIdRouteWithChildren
  '/resultat/$id/analyse': typeof ResultatIdAnalyseRoute
  '/resultat/$id/': typeof ResultatIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/historique'
    | '/login'
    | '/profil'
    | '/resultat/$id'
    | '/resultat/$id/analyse'
    | '/resultat/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/historique'
    | '/login'
    | '/profil'
    | '/resultat/$id/analyse'
    | '/resultat/$id'
  id:
    | '__root__'
    | '/'
    | '/historique'
    | '/login'
    | '/profil'
    | '/resultat/$id'
    | '/resultat/$id/analyse'
    | '/resultat/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoriqueRoute: typeof HistoriqueRoute
  LoginRoute: typeof LoginRoute
  ProfilRoute: typeof ProfilRoute
  ResultatIdRoute: typeof ResultatIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/historique': {
      id: '/historique'
      path: '/historique'
      fullPath: '/historique'
      preLoaderRoute: typeof HistoriqueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profil': {
      id: '/profil'
      path: '/profil'
      fullPath: '/profil'
      preLoaderRoute: typeof ProfilRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resultat/$id': {
      id: '/resultat/$id'
      path: '/resultat/$id'
      fullPath: '/resultat/$id'
      preLoaderRoute: typeof ResultatIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resultat/$id/': {
      id: '/resultat/$id/'
      path: '/'
      fullPath: '/resultat/$id/'
      preLoaderRoute: typeof ResultatIdIndexRouteImport
      parentRoute: typeof ResultatIdRoute
    }
    '/resultat/$id/analyse': {
      id: '/resultat/$id/analyse'
      path: '/analyse'
      fullPath: '/resultat/$id/analyse'
      preLoaderRoute: typeof ResultatIdAnalyseRouteImport
      parentRoute: typeof ResultatIdRoute
    }
  }
}

interface ResultatIdRouteChildren {
  ResultatIdAnalyseRoute: typeof ResultatIdAnalyseRoute
  ResultatIdIndexRoute: typeof ResultatIdIndexRoute
}

const ResultatIdRouteChildren: ResultatIdRouteChildren = {
  ResultatIdAnalyseRoute: ResultatIdAnalyseRoute,
  ResultatIdIndexRoute: ResultatIdIndexRoute,
}

const ResultatIdRouteWithChildren = ResultatIdRoute._addFileChildren(
  ResultatIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoriqueRoute: HistoriqueRoute,
  LoginRoute: LoginRoute,
  ProfilRoute: ProfilRoute,
  ResultatIdRoute: ResultatIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
